// ============================================================
// Rush default window — full rollout (no A/B gate).
// During the configured rush window the PDP pre-selects the SECOND
// available delivery option instead of the soonest, so customers
// ordering in the same-week premium-shipping window default to the
// next normal shipping week. The sooner option stays selectable.
// Applies to all visitors — no URL parameter, no cohort split.
// Gated only by the shop metafield custom.rush_default_window:
//   - enabled: false      -> skip never fires (kill switch)
//   - outside the window  -> soonest option, unchanged behavior
// ============================================================
const ShipDefaultPolicy = (function () {
    const DAY_INDEX = { sunday: 0, monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6 };

    function readConfig() {
        const el = document.querySelector('script[data-rush-default-window-config]');
        if (!el) return null;
        try { return JSON.parse(el.textContent.trim()); }
        catch (e) { console.warn('rush_default_window: invalid JSON', e); return null; }
    }

    function minuteOfWeek(date, timezone) {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: timezone, hour12: false,
            weekday: 'long', hour: '2-digit', minute: '2-digit'
        }).formatToParts(date).reduce((acc, p) => (acc[p.type] = p.value, acc), {});
        const dow = DAY_INDEX[parts.weekday.toLowerCase()];
        const hh = parseInt(parts.hour, 10) % 24;
        const mm = parseInt(parts.minute, 10);
        return dow * 1440 + hh * 60 + mm;
    }
    function timeToMow(day, hhmm) {
        const dow = DAY_INDEX[day.toLowerCase()];
        const [hh, mm] = hhmm.split(':').map(Number);
        return dow * 1440 + hh * 60 + mm;
    }

    function isNowInsideRushWindow(config) {
        if (!config || !config.enabled) return false;
        const tz = config.timezone || 'America/New_York';
        const now = minuteOfWeek(new Date(), tz);
        const start = timeToMow(config.starts.day, config.starts.time);
        const end = timeToMow(config.ends.day, config.ends.time);
        return start <= end ? (now >= start && now <= end) : (now >= start || now <= end);
    }

    function shouldSkipSoonest() {
        const config = readConfig();
        if (!config) return false;
        return isNowInsideRushWindow(config);
    }

    return { shouldSkipSoonest, readConfig };
})();

// Call initializeFormPDP on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function () {
    initializeFormPDP();
});

function initializeFormPDP() {
    const boxPdpFirstDeliveryDropdown = document.querySelector('.first-delivery-dropdown');
    const boxPdpDeliveryItemValueWrapper = document.querySelectorAll('.box-pdp__delivery-item-value-wrapper');
    const calendarType = document.querySelector('.product-form-v2').getAttribute('data-calendar-type');
    const calendarDatePicker = document.querySelector('#calendar-container');
    const customDates = document.querySelector('.box-pdp--calendar-dropdown').getAttribute('data-custom-dates') ? JSON.parse(document.querySelector('.box-pdp--calendar-dropdown').getAttribute('data-custom-dates')) : [];
    const pdpBoxTypeSelectors = document.querySelectorAll('.box-pdp--box-type .box-pdp__selection');

    // extra products popup
    const popup = document.getElementById('extra-products-popup');
    const popupShow = popup ? popup.getAttribute('data-show') === 'true' : false;
    const isSingleAddonPopup = popup ? popup.getAttribute('data-single-addon') === 'true' : false;
    const isIncrementalCart = popup ? popup.getAttribute('data-incremental-cart') === 'true' : false;
    const closePopupButton = document.getElementById('close-extra-products-popup');
    const checkoutButton = document.getElementById('extra-products-popup__checkout-button');
    const checkoutSkipButton = document.getElementById('extra-products-popup__skip');
    const singleAddonAddBtn = document.getElementById('extra-products-popup__single-addon-add');

    if (checkoutButton) {
        checkoutButton.dataset.defaultCta = checkoutButton.textContent.trim();
    }

    console.log('popupShow', popupShow);

    let items = [];




    if (pdpBoxTypeSelectors.length > 0) {
        pdpBoxTypeSelectors.forEach(selector => {
            selector.addEventListener('click', function () {
                const handle = this.getAttribute('data-handle');
                const section_id = this.getAttribute('data-section-id');
                renderShopifyProduct(handle, section_id);
            });
        });
    }

    if (boxPdpFirstDeliveryDropdown) {
        console.log('boxPdpFirstDeliveryDropdown');
        const selectedOption = boxPdpFirstDeliveryDropdown.querySelector('.box-pdp--custom-dropdown__selected');
        const optionsContainer = boxPdpFirstDeliveryDropdown.querySelector('.box-pdp--custom-dropdown__options');

        if (!boxPdpFirstDeliveryDropdown.classList.contains('custom-shipping-dates') && calendarType === 'dropdown') {
            // Generate delivery options
            const options = generateDeliveryOptions(12);

            // Populate options
            optionsContainer.innerHTML = options.map(option =>
                `<div class="box-pdp--custom-dropdown__option" data-value="${option.value}" data-ship="${option._ship}">${option.label}</div>`
            ).join('');
        }

        // Variation theme: pre-select the SECOND option during the rush window.
        // Outside the window shouldSkipSoonest() returns false, so the picker
        // falls back to the soonest option exactly like the control theme.
        (function applyDefaultPolicyToDropdown() {
            if (calendarType !== 'dropdown') return;
            if (!ShipDefaultPolicy.shouldSkipSoonest()) return;

            const allOptions = optionsContainer.querySelectorAll('.box-pdp--custom-dropdown__option');
            if (allOptions.length < 2) return;

            const chosen = allOptions[1];
            if (!chosen) return;

            selectedOption.textContent = chosen.textContent;
            const valueEl = document.querySelector('.item--first-delivery-value');
            if (valueEl) {
                valueEl.textContent = chosen.textContent;
                valueEl.setAttribute('data-ship', chosen.getAttribute('data-ship'));
            }
        })();

        if (calendarDatePicker && calendarType === 'date-picker') {
            // console.log('calendarDatePicker starting');
            console.log('customDates', customDates);
            const today = new Date();
            let enableDates = [];
            if (customDates && customDates.length > 0) {
                enableDates = customDates
                    .filter(dateRange => {
                        if (dateRange.shipping_date_expires && dateRange.shipping_date_expires !== '') {
                            const cutOffDate = new Date(dateRange.shipping_date_expires);
                            const today = new Date();
                            // console.log('dateRange.shipping_date_expires', dateRange.shipping_date_expires, today);
                            return cutOffDate >= today;
                        } else {

                            const shippingDate = new Date(dateRange.shipping_date + 'T00:00:00');
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);
                            // console.log('dateRange.shipping_date', dateRange.shipping_date, today);
                            return shippingDate >= today;
                        }
                    })
                    .map(dateRange => ({
                        from: new Date(dateRange.delivery_start_date + 'T00:00:00'),
                        to: new Date(dateRange.delivery_end_date + 'T23:59:59')
                    }));
            } else {
                console.log('no custom dates');
                const cutOffDate = new Date(today);

                enableDates = Array.from({ length: 12 }, (_, i) => {
                    // Create date in local timezone
                    const startDate = new Date(today);
                    startDate.setHours(0, 0, 0, 0);
                    console.log('startDate', startDate);

                    // If current day is after Monday and time is after 9am, move to next week

                    if (cutOffDate.getDay() >= 1 && cutOffDate.getHours() > 8) {
                        startDate.setDate(startDate.getDate() + 7);
                    }

                    // Find next Wednesday
                    startDate.setDate(startDate.getDate() + ((2 + 7 - startDate.getDay()) % 7) + (i * 7));
                    startDate.setHours(0, 0, 0, 0);
                    console.log('startDate', startDate);

                    const endDate = new Date(startDate);
                    endDate.setDate(endDate.getDate() + 3); // Friday is 2 days after Wednesday

                    // Create ISO strings but preserve the local dates

                    endDate.setHours(23, 59, 59, 999);

                    return {
                        from: startDate,
                        to: endDate
                    };
                });
            }
            console.log('enableDates', enableDates);

            // Variation theme: during the rush window pick the SECOND chronologically
            // valid range and skip the soonest. Outside the window this falls back to
            // the original .find() selection, identical to the control theme.
            let firstValidRange;
            if (ShipDefaultPolicy.shouldSkipSoonest()) {
                const sorted = enableDates
                    .filter(range => range.from != null && range.to != null)
                    .sort((a, b) => a.from - b.from);
                firstValidRange = sorted.length >= 2 ? sorted[1] : sorted[0];
            } else {
                firstValidRange = enableDates.find(range => range.from != null && range.to != null);
            }
            const defaultDate = firstValidRange ? [
                new Date(firstValidRange.from),
                new Date(firstValidRange.to)
            ] : null;
            console.log('defaultDate', defaultDate);

            const calendar = flatpickr("#delivery-date-input", {
                mode: "range",
                dateFormat: "F j, Y",
                appendTo: document.getElementById('calendar-container'),
                static: true,
                inline: true,
                // minDate: new Date(today.setHours(0, 0, 0, 0)),
                minDate: enableDates.length > 0 ? enableDates[0].from : null,
                maxDate: enableDates.length > 0 ? new Date(enableDates[enableDates.length - 1].to.getTime() + 24 * 60 * 60 * 1000) : null,
                firstDayOfWeek: 0,
                enable: [
                    function (date) {
                        // Only allow Wednesday (3), Thursday (4), or Friday (5)
                        // if (!customDates || customDates.length === 0) {
                        //     if (date.getDay() !== 3 && date.getDay() !== 4 && date.getDay() !== 5) {
                        //         return false;
                        //     }
                        // }

                        // Check if the date falls within any of our enabled ranges
                        return enableDates.some(range =>
                            date >= range.from && date <= range.to
                        );
                    }
                ],
                defaultDate: defaultDate,
                onChange: function (selectedDates, dateStr, instance) {
                    if (selectedDates.length === 1) {
                        // Find the matching range for the selected date
                        const date = selectedDates[0];
                        const matchingRange = enableDates.find(range =>
                            date >= range.from && date <= range.to
                        );

                        if (matchingRange) {
                            instance.setDate([matchingRange.from, matchingRange.to], true);
                        } else {
                            instance.clear();
                        }
                    } else if (selectedDates.length === 2) {
                        const startDate = selectedDates[0];
                        const endDate = selectedDates[1];

                        // Find matching range that contains both dates
                        const matchingRange = enableDates.find(range =>
                            startDate >= range.from && endDate <= range.to
                        );

                        if (!matchingRange) {
                            instance.clear();
                        } else {
                            selectedOption.textContent = formatDateRange(startDate, endDate);
                            document.querySelector('.item--first-delivery-value').textContent = selectedOption.textContent;
                            const calendarShipDate = new Date(startDate);
                            // Find the Monday before the delivery date (which is 3 days before)
                            const daysToMonday = ((calendarShipDate.getDay() + 7) - 1) % 7;
                            calendarShipDate.setDate(calendarShipDate.getDate() - daysToMonday);
                            const calendar_ship = formatYYYYMMDD(calendarShipDate);
                            document.querySelector('.item--first-delivery-value').setAttribute('data-ship', calendar_ship);
                            boxPdpFirstDeliveryDropdown.classList.remove('open');
                        }
                    }

                    setTimeout(() => {
                        const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
                        attachHoverListeners(dayElements);
                    }, 0);
                },
                onMonthChange: function (date, instance) {
                    setTimeout(() => {
                        const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
                        attachHoverListeners(dayElements);
                    }, 0);
                },
                onYearChange: function (date, instance) {
                    setTimeout(() => {
                        const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
                        attachHoverListeners(dayElements);
                    }, 0);
                },
                onReady: function (selectedDates, dateStr, instance) {


                    if (selectedDates && selectedDates.length === 2) {
                        selectedOption.textContent = formatDateRange(selectedDates[0], selectedDates[1]);
                        document.querySelector('.item--first-delivery-value').textContent = selectedOption.textContent;
                        const calendarShipDate = new Date(selectedDates[0]);
                        // Find the Monday before the delivery date (which is 3 days before)
                        const daysToMonday = ((calendarShipDate.getDay() + 7) - 1) % 7;
                        calendarShipDate.setDate(calendarShipDate.getDate() - daysToMonday);
                        const calendar_ship = formatYYYYMMDD(calendarShipDate);
                        document.querySelector('.item--first-delivery-value').setAttribute('data-ship', calendar_ship);
                    }
                }
            });

            function formatYYYYMMDD(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }

            function formatDateRange(startDate, endDate) {
                const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

                if (startDate.getMonth() === endDate.getMonth()) {
                    // Same month format: "December  4 -  6"
                    return `${months[startDate.getMonth()]}  ${startDate.getDate()} -  ${endDate.getDate()}`;
                } else {
                    // Different months format: "December  31 - January  2"
                    return `${months[startDate.getMonth()]}  ${startDate.getDate()} - ${months[endDate.getMonth()]}  ${endDate.getDate()}`;
                }
            }

            const calendarContainer = calendar.calendarContainer;
            if (calendarContainer) {
                const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');

                function attachHoverListeners(dayElements) {
                    Array.from(dayElements).forEach(dayElem => {
                        dayElem.removeEventListener('mouseover', handleDayHover);
                        dayElem.addEventListener('mouseover', handleDayHover);
                    });
                }

                function handleDayHover(e) {
                    if (!e.target.classList.contains('flatpickr-disabled')) {
                        const date = new Date(e.target.dateObj);

                        // Clear all hover states first
                        Array.from(dayElements).forEach(el => {
                            el.classList.remove('hover-in-range');
                            el.classList.remove('hover-startRange');
                            el.classList.remove('hover-endRange');
                        });

                        // Find the matching date range for the hovered date
                        const matchingRange = enableDates.find(range =>
                            date >= range.from && date <= range.to
                        );

                        if (matchingRange) {
                            Array.from(dayElements).forEach(el => {
                                if (!el.classList.contains('flatpickr-disabled') &&
                                    !el.classList.contains('selected') &&
                                    !el.classList.contains('startRange') &&
                                    !el.classList.contains('endRange') &&
                                    !el.classList.contains('inRange')) {

                                    const elementDate = new Date(el.dateObj);

                                    // Compare dates ignoring time
                                    const isStartDate = elementDate.toDateString() === matchingRange.from.toDateString();
                                    const isEndDate = elementDate.toDateString() === new Date(matchingRange.to.getTime() - (23 * 60 * 60 * 1000 + 59 * 60 * 1000 + 59 * 1000)).toDateString();
                                    const isInRange = elementDate > matchingRange.from && elementDate < matchingRange.to && !isEndDate;

                                    if (isStartDate) {
                                        el.classList.add('hover-startRange');
                                    } else if (isEndDate) {
                                        el.classList.add('hover-endRange');
                                    } else if (isInRange) {
                                        el.classList.add('hover-in-range');
                                    }
                                }
                            });
                        }
                    } else {
                        // Clear hover states when hovering disabled dates
                        Array.from(dayElements).forEach(el => {
                            if (!el.classList.contains('selected') &&
                                !el.classList.contains('startRange') &&
                                !el.classList.contains('endRange') &&
                                !el.classList.contains('inRange')) {
                                el.classList.remove('hover-in-range');
                                el.classList.remove('hover-startRange');
                                el.classList.remove('hover-endRange');
                            }
                        });
                    }
                }
                // Initial attachment of hover listeners
                attachHoverListeners(dayElements);

                // Add mouseleave handler to clear hover states
                calendarContainer.addEventListener('mouseleave', () => {
                    Array.from(dayElements).forEach(el => {
                        el.classList.remove('hover-in-range');
                        el.classList.remove('hover-startRange');
                        el.classList.remove('hover-endRange');
                    });
                });
            }
        }

        selectedOption.addEventListener('click', function () {
            boxPdpFirstDeliveryDropdown.classList.toggle('open');
        });

        optionsContainer.addEventListener('click', function (event) {
            if (event.target.classList.contains('box-pdp--custom-dropdown__option')) {
                selectedOption.textContent = event.target.textContent;
                document.querySelector('.item--first-delivery-value').textContent = event.target.textContent;
                document.querySelector('.item--first-delivery-value').setAttribute('data-ship', event.target.getAttribute('data-ship'));
                boxPdpFirstDeliveryDropdown.classList.remove('open');
                boxPdpFirstDeliveryDropdown.classList.remove('active');
            }
        });
    }

    if (boxPdpDeliveryItemValueWrapper) {
        boxPdpDeliveryItemValueWrapper.forEach(wrapper => {
            wrapper.addEventListener('click', function (event) {
                event.stopPropagation();
                const dropdownTarget = this.getAttribute('data-dropdown-target');
                const dropdown = document.querySelector(`.${dropdownTarget}`);

                closeAllDropdowns();

                dropdown.classList.toggle('active');
                dropdown.classList.toggle('open');
            });
        });
    }

    function calculateNextBillingDate(shipDate, frequencyLabel) {
        // if no selling plan, return null
        if (product_1.sellingPlanGroups.length === 0) return null;
        // If gift is selected, return null
        if (document.querySelector('#subscriptionGift') && document.querySelector('#subscriptionGift').checked) return null;

        const today = new Date();
        const date = new Date(shipDate + 'T00:00:00');

        // Check if selected date is at least 7 days from today
        const minimumDate = new Date(today);
        minimumDate.setDate(today.getDate() + 7);

        if (date < minimumDate) {
            return null;
        }


        const matches = frequencyLabel.match(/every (\d+) (month|weeks)/i);
        if (!matches) return shipDate;

        const [_, number, unit] = matches;

        if (unit.toLowerCase() === 'month') {
            date.setMonth(date.getMonth() + parseInt(number));
        } else if (unit.toLowerCase() === 'weeks') {
            date.setDate(date.getDate() + (parseInt(number) * 7));
        }

        return formatYYYYMMDD(date);
    }


    var productLockVariantsSelectors = document.querySelectorAll('.product-form-v2 input[name="box-size"]');
    if (productLockVariantsSelectors) {
        productLockVariantsSelectors.forEach((selector) => {
            selector.addEventListener('change', function () {
                const price = selector.getAttribute('data-price');
                const compareAtPrice = selector.getAttribute('data-compare-at-price');

                const regularPriceElement = document.querySelector('.product-block--price .regular-price');
                const compareAtPriceElement = document.querySelector('.product-block--price .compare-at-price');
                const purchaseOptions = document.querySelector('.purchase-options');
                const frequencySelector = document.querySelector('.box-pdp__selections.frequency-selector');

                const addToCartButtonPrice = document.querySelector('.box-pdp__add-to-cart-button-price');
                const stickyAddToCartButtonPrice = document.querySelector('.sticky-add-to-cart__button-price');

                if (regularPriceElement && price) {
                    regularPriceElement.innerHTML = price;
                }
                if (addToCartButtonPrice && price) {
                    addToCartButtonPrice.innerHTML = price;
                }
                if (stickyAddToCartButtonPrice && price) {
                    stickyAddToCartButtonPrice.innerHTML = price;
                }
                if (compareAtPriceElement && compareAtPrice) {
                    compareAtPriceElement.innerHTML = compareAtPrice;
                }

                if (purchaseOptions) {
                    purchaseOptions.querySelector('.original-price')
                        ? (purchaseOptions.querySelector('.original-price').innerHTML = compareAtPrice)
                        : null;
                    purchaseOptions.querySelector('.regular-price')
                        ? (purchaseOptions.querySelector('.regular-price').innerHTML = price)
                        : null;
                    purchaseOptions.querySelector('.compare-at-price')
                        ? (purchaseOptions.querySelector('.compare-at-price').innerHTML = compareAtPrice)
                        : null;
                }

                if (frequencySelector) {
                    updateFrequencyInfo(parseInt(selector.value));
                }
            });
        });
    }
    var frequencySelectors = document.querySelectorAll('.product-form-v2 .frequency-selector .box-pdp__selection');
    if (frequencySelectors) {
        frequencySelectors.forEach((selector) => {
            selector.addEventListener('click', function () {
                updateStickyAddToCartFrequency(selector.textContent);
                updateUnderButtonFrequency(selector.textContent);
            });
        });
    }

    const checkedFrequencyInput = document.querySelector('.product-form-v2 .frequency-selector input[name="frequency"]:checked');
    if (checkedFrequencyInput && checkedFrequencyInput.nextElementSibling) {
        const checkedFrequencyLabel = checkedFrequencyInput.nextElementSibling.textContent.trim();
        updateStickyAddToCartFrequency(checkedFrequencyLabel);
        updateUnderButtonFrequency(checkedFrequencyLabel);
    }

    var productLockBoxButton = document.querySelector('.product-lock__box-button');
    var productLockBoxButton_item = null;
    if (productLockBoxButton) {
        productLockBoxButton.addEventListener('click', function () {
            const variantId = productLockBoxButton.getAttribute('data-id');
            console.log('variantId', variantId);
            if (variantId) {
                productLockBoxButton_item = {
                    id: parseInt(variantId),
                    quantity: 1,
                };
                const pageLock = document.querySelector('.product-locked');
                const unlockText = document.querySelector('.product-lock-unlocked-text');
                if (pageLock) {
                    pageLock.classList.remove('product-locked');
                }
                if (unlockText) {
                    unlockText.classList.remove('hidden');
                }
            }
        });
    }
    var productV2ByobButton = document.querySelector('.box-pdp__byob-button');
    if (productV2ByobButton) {
        productV2ByobButton.addEventListener('click', function () {
            const location = productV2ByobButton.getAttribute('data-location');
            if (!location) return;
            const boxSize = document.querySelector('.product-form-v2 input[name="box-size"]:checked').nextElementSibling.textContent.split('(Serves')[0].trim();
            const boxFrequency = document.querySelector('.product-form-v2 input[name="frequency"]:checked').nextElementSibling.textContent.trim();
            console.log('boxSize', boxSize);
            console.log('boxFrequency', boxFrequency);
            const queryParams = '?' + (boxSize ? 'box-size=' + boxSize : '') + (boxFrequency ? '&frequency=' + boxFrequency : '');
            console.log('queryParams', location + queryParams);
            window.location.href = location + queryParams;
        });
    }
    var productV2AddToCart = document.querySelector('.box-pdp__v2-form-add-to-cart');
    console.log('productV2AddToCart', productV2AddToCart);
    if (productV2AddToCart) {
        productV2AddToCart.addEventListener('click', async function () {

            items = [];

            const variantId = document.querySelector('.product-form-v2 input[name="box-size"]:checked').value;
            const sellingPlanId = document.querySelector('.product-form-v2 input[name="frequency"]')
                ? document.querySelector('.product-form-v2 input[name="frequency"]:checked').value
                : null;
            const deliveryLabel = sellingPlanId ? 'First Delivery Window' : 'Delivery Window';

            // Get shipping date and frequency
            const shipDate = document.querySelector('.item--first-delivery-value').getAttribute('data-ship') ? document.querySelector('.item--first-delivery-value').getAttribute('data-ship') : null;
            const frequencyLabel = document.querySelector('.frequency-selector input[type="radio"]:checked')
                ? document.querySelector('.frequency-selector input[type="radio"]:checked').nextElementSibling.textContent.trim()
                : '';

            // Calculate next billing date
            const nextBillingDate = sellingPlanId && shipDate != '' && shipDate != null && frequencyLabel != '' ? calculateNextBillingDate(shipDate, frequencyLabel) : null;
            var giftCreditProperties = window.AppyGiftCredit && typeof window.AppyGiftCredit.preparedProperties === 'function'
                ? window.AppyGiftCredit.preparedProperties(productV2AddToCart)
                : {};
            var isGiftCreditPurchase = giftCreditProperties._appy_gift_version === 'v2';
            var properties = {};
            if (document.querySelector('#subscriptionGift') && document.querySelector('#subscriptionGift').checked) {
                properties = {};
            } else if (!isGiftCreditPurchase) {
                properties = {
                    'Shipping Date': document.querySelector('.product-form-v2 input[name="properties[Shipping Date]"]')
                        ? document.querySelector('.product-form-v2 input[name="properties[Shipping Date]"]').value
                        : null,
                    [deliveryLabel]: document.querySelector('.item--first-delivery-value')
                        ? document.querySelector('.item--first-delivery-value').textContent
                        : null,
                    '_SHIP': shipDate,
                    '_NEXT_BILLING_DATE': nextBillingDate
                };
            }
            var customerPrefProperties = document.querySelectorAll('.preferences-item input[type="checkbox"]:checked');
            if (!isGiftCreditPurchase && customerPrefProperties) {
                let properties_preferences = '';
                customerPrefProperties.forEach(property => {
                    properties_preferences += property.value;
                    if (property != customerPrefProperties[customerPrefProperties.length - 1]) {
                        properties_preferences += ', ';
                    }
                    properties['_PREF_' + property.value.toUpperCase()] = property.value.toUpperCase();
                });
                if (properties_preferences != '') {
                    properties['Preferences'] = properties_preferences;
                }
            }
            if (document.querySelector('#subscriptionGift') && document.querySelector('#subscriptionGift').checked) {
                properties['__rc_gift_recipient_email'] = document.querySelector('#gift_recipient_email').value ? document.querySelector('#gift_recipient_email').value : null;
                properties['__rc_gift_recipient_first_name'] = document.querySelector('#gift_recipient_first_name').value ? document.querySelector('#gift_recipient_first_name').value : null;
                properties['__rc_gift_recipient_last_name'] = document.querySelector('#gift_recipient_last_name').value ? document.querySelector('#gift_recipient_last_name').value : null;
                properties['__rc_gift_recipient_note'] = document.querySelector('#gift_message').value ? document.querySelector('#gift_message').value : null;
                properties['__rc_gift_sender_name'] = document.querySelector('#gift_sender_name').value ? document.querySelector('#gift_sender_name').value : null;
                properties['__rc_gift_notification_scheduled_at'] = document.querySelector('#gift_notification_scheduled_at').value ? document.querySelector('#gift_notification_scheduled_at').value : null;

                if (!properties['__rc_gift_recipient_email'] || !validateEmail(properties['__rc_gift_recipient_email'])) {
                    document.querySelector('#gift_recipient_email').classList.add('error');
                } else {
                    document.querySelector('#gift_recipient_email').classList.remove('error');
                }
                if (!properties['__rc_gift_recipient_first_name']) {
                    document.querySelector('#gift_recipient_first_name').classList.add('error');
                } else {
                    document.querySelector('#gift_recipient_first_name').classList.remove('error');
                }
                if (!properties['__rc_gift_recipient_last_name']) {
                    document.querySelector('#gift_recipient_last_name').classList.add('error');
                } else {
                    document.querySelector('#gift_recipient_last_name').classList.remove('error');
                }
                if (!properties['__rc_gift_recipient_email'] || !validateEmail(properties['__rc_gift_recipient_email']) || !properties['__rc_gift_recipient_first_name'] || !properties['__rc_gift_recipient_last_name']) {
                    return;
                }
            }

            if (!isGiftCreditPurchase && document.querySelector('[data-offer-value]')) {
                properties['_offer'] = document.querySelector('[data-offer-value]').value;
            }
            Object.assign(properties, giftCreditProperties);

            if (isGiftCreditPurchase && productV2AddToCart.dataset.appyGiftPurchaseInFlight === 'true') {
                return;
            }
            if (isGiftCreditPurchase) {
                productV2AddToCart.dataset.appyGiftPurchaseInFlight = 'true';
                productV2AddToCart.disabled = true;
            }

            if (isGiftCreditPurchase && window.AppyGiftCredit && typeof window.AppyGiftCredit.ensureCompatibleCart === 'function') {
                try {
                    await window.AppyGiftCredit.ensureCompatibleCart(window, true);
                } catch (error) {
                    delete productV2AddToCart.dataset.appyGiftPurchaseInFlight;
                    productV2AddToCart.disabled = false;
                    window.alert(error && error.message ? error.message : 'The cart could not be checked. Refresh the page and try again.');
                    return;
                }
            }

            if (document.querySelector('.product-form-v2 .purchase-options')) {
                const membershipProductId = document
                    .querySelector('.product-form-v2 input[name="purchase-option"]:checked')
                    .getAttribute('data-membership-id');
                const purchaseOption = document.querySelector('.product-form-v2 input[name="purchase-option"]:checked').value;
                if (purchaseOption === 'join_and_save' && membershipProductId) {
                    const membershipItem = {
                        id: parseInt(membershipProductId),
                        quantity: 1,
                    };
                    items.push(membershipItem);
                }
            }
            if (productLockBoxButton_item) {
                items.push(productLockBoxButton_item);
            }

            const item = {
                id: parseInt(variantId),
                selling_plan: isGiftCreditPurchase ? null : (sellingPlanId ? parseInt(sellingPlanId) : null),
                quantity: 1,
                properties: properties,
            };
            items.push(item);

            console.log('variantId', variantId);

            // free gift products
            const freeGiftProducts = document.querySelectorAll('input[name="free_gift_products"]:checked');
            if (freeGiftProducts) {
                freeGiftProducts.forEach(product => {
                    const freeGiftProductId = product.value;
                    items.push({ id: parseInt(freeGiftProductId), quantity: 1, parent_id: parseInt(variantId), properties: { 'Type': 'Free Gift' } });
                });
            }
            if (items.length > 0) {
                if (popupShow) {
                    if (isIncrementalCart) {
                        productV2AddToCart.disabled = true;
                        removeIncrementalCartLines(popup)
                            .then(() => incrementCartAdd(items, true))
                            .then((data) => {
                                popup.dataset.mainVariantId = String(variantId);
                                const responseItems = data && Array.isArray(data.items) ? data.items : [];
                                popup.dataset.addedLineKeys = JSON.stringify(responseItems.map((it) => it && it.key).filter(Boolean));
                                const mainLine = responseItems.find((it) => Number(it && (it.variant_id || it.id)) === Number(variantId));
                                if (mainLine && mainLine.key) {
                                    popup.dataset.mainLineKey = String(mainLine.key);
                                } else {
                                    delete popup.dataset.mainLineKey;
                                    console.warn('[PDP add-to-cart] Could not resolve main line key from /cart/add.js response. Extras will be added without parent_id.', { variantId, responseItems });
                                }
                                popup.style.display = 'block';
                                document.body.classList.add('popup-open');
                                document.documentElement.classList.add('html-popup-open');
                                items = [];
                            })
                            .catch((error) => {
                                console.error('Error adding main product(s) to cart:', error);
                                productV2AddToCart.disabled = false;
                            });
                    } else {
                        popup.dataset.mainVariantId = String(variantId);
                        popup.style.display = 'block';
                        document.body.classList.add('popup-open');
                        document.documentElement.classList.add('html-popup-open');
                    }

                } else {
                    lockProductAddToCart(items, 'checkout', isGiftCreditPurchase ? function () {
                        delete productV2AddToCart.dataset.appyGiftPurchaseInFlight;
                        productV2AddToCart.disabled = false;
                    } : null);
                }



            }
        });
    }

    const purchaseOptionInputs = document.querySelectorAll('input[name="purchase-option"]');
    if (purchaseOptionInputs) {
        purchaseOptionInputs.forEach(input => {
            input.addEventListener('change', function () {
                const buttonText = input.getAttribute('data-button-text');
                document.querySelector('.box-pdp__v2-form-add-to-cart').textContent = buttonText;
            });
        });
    }
    if (purchaseOptionInputs.length > 1) {
        purchaseOptionInputs[1].checked = true;
        purchaseOptionInputs[1].dispatchEvent(new Event('change'));
    }

    if (boxPdpFirstDeliveryDropdown) {
        if (calendarType === 'dropdown') {
            boxPdpFirstDeliveryDropdown.querySelectorAll('.box-pdp--custom-dropdown__option')[0].click();
        }
    }

    // preferences
    const preferences = document.querySelectorAll('.preferences-item input[type="checkbox"]');
    if (preferences) {
        preferences.forEach(preference => {
            preference.addEventListener('change', function (event) {
                if (event.target.checked) {
                    addPreferenceButton(event.target.value);
                } else {
                    removePreferenceButton(event.target.value);
                }
            });
        });
    }
    const preferencesRemoveButtons = document.querySelectorAll('.preferences-button__remove');
    if (preferencesRemoveButtons) {
        preferencesRemoveButtons.forEach(button => {
            button.addEventListener('click', function () {
                removePreferenceButton(button.getAttribute('data-value'));
            });
        });
    }
    function addPreferenceButton(preference) {
        if (!preference) { return; }
        const appendWrapper = document.querySelector('.box-pdp__step-title--preferences');
        if (!appendWrapper) { return; }

        const preferenceButton = document.createElement('div');
        preferenceButton.classList.add('preferences-button');
        preferenceButton.setAttribute('data-value', preference);
        preferenceButton.innerHTML = `<div class="preferences-button__name">${preference}</div><div class="preferences-button__remove" data-value="${preference}">X</div>`;
        preferenceButton.querySelector('.preferences-button__remove').addEventListener('click', function () {
            removePreferenceButton(preference);
        });
        appendWrapper.appendChild(preferenceButton);

    }
    function removePreferenceButton(preference) {
        if (!preference) { return; }
        const preferenceButton = document.querySelector(`.preferences-button[data-value="${preference}"]`);
        const preferenceCheckbox = document.querySelector(`input[type="checkbox"][value="${preference}"]`);
        if (preferenceButton) {
            preferenceButton.remove();
        }
        if (preferenceCheckbox) {
            preferenceCheckbox.checked = false;
        }
    }
    // preselect frequency
    // const frequencyWrapperBelowButton = document.querySelector('.box-pdp__step--frequency-selector');
    // if (frequencyWrapperBelowButton){
    //     updateUnderButtonFrequency(document.querySelector('.frequency-selector input[name="frequency"]:checked').nextElementSibling.textContent);
    // }

    // preselect box size
    const boxSizeInput = document.querySelector('input[name="box-size"]:checked');
    if (boxSizeInput) {
        boxSizeInput.dispatchEvent(new Event('change'));
    }

    function proceedExtraProductsPopupSkipCheckout() {
        if (checkoutSkipButton) checkoutSkipButton.disabled = true;
        if (checkoutButton) checkoutButton.disabled = true;
        if (singleAddonAddBtn) singleAddonAddBtn.disabled = true;
        if (closePopupButton) closePopupButton.disabled = true;
        if (isIncrementalCart) {
            window.location.href = '/checkout';
        } else {
            lockProductAddToCart(items.reverse(), 'checkout');
        }
    }

    // Close (×) returns the customer to the PDP — no checkout redirect. In incremental mode the box
    // stays in the cart (abandoned-popup recovery); the next Order Now click removes those lines
    // first (removeIncrementalCartLines) so re-ordering can't double-add the box.
    if (closePopupButton) {
        closePopupButton.addEventListener('click', function () {
            resetPdpExtraProductsPopupUi();
            if (productV2AddToCart) {
                productV2AddToCart.disabled = false;
            }
        });
    }

    // Clicking outside the popup intentionally does nothing — the only ways out are the ×,
    // Skip, or Checkout. (It used to close and, in incremental mode, redirect to checkout.)

    // Product More Info popup (gallery, carousel and zoom) is handled by the
    // shared product-info-popup.js via delegated handlers on the card markup.

    // Free gift uses the same popup but is triggered from a non-card element.
    const freeGiftMoreInfoButtons = document.querySelectorAll('.box-pdp__free-gifts-carousel-item-info-link[data-free-gift-more-info-button]');
    freeGiftMoreInfoButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            if (window.ProductInfoPopup) {
                window.ProductInfoPopup.openFromButton(button);
            }
        });
    });

    // Extras Qty selectors
    const quantityContainers = document.querySelectorAll('.purchase-flow-step__quantity-selector');

    quantityContainers.forEach(container => {
        const decreaseBtn = container.querySelector('.decrease');
        const increaseBtn = container.querySelector('.increase');
        const input = container.querySelector('input');

        decreaseBtn.addEventListener('click', () => updateQuantity(input, -1));
        increaseBtn.addEventListener('click', () => updateQuantity(input, 1));
        input.addEventListener('change', () => validateInput(input));

    });

    function updateQuantity(input, change) {
        let newValue = parseInt(input.value) + change;
        newValue = Math.max(parseInt(input.min), Math.min(parseInt(input.max), newValue));
        input.value = newValue;
        if (newValue === 0) {
            input.closest('.purchase-flow-step__quantity-selector').style.display = 'none';
            input.closest('.purchase-flow__product-card').classList.remove('active');
            input.closest('.purchase-flow__product-card').querySelector('[data-add-to-order]').style.display = 'block';
        }
    }

    function validateInput(input) {
        let value = parseInt(input.value);
        value = Math.max(parseInt(input.min), Math.min(parseInt(input.max), value));
        input.value = value;
    }

    const addToOrderButtons = document.querySelectorAll('[data-add-to-order]');

    addToOrderButtons.forEach(button => {
        button.addEventListener('click', function () {
            // console.log('addToOrder');
            if (checkoutButton) checkoutButton.textContent = 'Checkout →';
            button.style.display = 'none';
            button.closest('.purchase-flow__product-card').querySelector('.purchase-flow-step__quantity-selector').style.display = 'flex';
            button.closest('.purchase-flow__product-card').classList.add('active');
            button.closest('.purchase-flow__product-card').querySelector('.purchase-flow-step__quantity-selector input').value = 1;
        });
    });

    // Extra products checkout button

    if (checkoutButton) {
        checkoutButton.addEventListener('click', function () {
            checkoutButton.disabled = true;
            checkoutButton.textContent = 'Checking out...';

            if (isIncrementalCart) {
                items = [];
            }
            const parentLineKey = popup && popup.dataset.mainLineKey ? popup.dataset.mainLineKey : null;
            const activeExtraProducts = document.querySelectorAll('.extra-products-popup .purchase-flow__product-card.active');
            if (activeExtraProducts.length > 0) {
                activeExtraProducts.forEach(product => {
                    const productId = product.querySelector('[data-product-id]').getAttribute('data-variant-id');
                    const quantity = parseInt(product.querySelector('.purchase-flow-step__quantity-selector input').value);
                    const productName = product.querySelector('[data-product-name]').getAttribute('data-product-name');
                    const productPrice = parseFloat(product.querySelector('[data-product-price]').getAttribute('data-product-price'));
                    const extraItem = { id: parseInt(productId), quantity: quantity, properties: { 'Type': 'Extra Item' } };
                    if (isIncrementalCart) {
                        // Parent line already exists in the cart from the earlier
                        // /cart/add.js request, so we nest extras under it via
                        // `parent_line_key` (Shopify Ajax Cart API for nested cart lines).
                        // See https://shopify.dev/docs/apps/build/product-merchandising/nested-cart-lines/create-nested-cart-lines
                        if (parentLineKey) {
                            extraItem.parent_line_key = parentLineKey;
                        }
                    } else if (items.length > 0) {
                        extraItem.parent_id = parseInt(items[0].id);
                    }
                    items.push(extraItem);

                    // fbq('track', 'AddToCart', {
                    //   value: (productPrice * quantity).toFixed(2),
                    //   currency: 'USD',
                    //   content_name: productName,
                    //   content_type: 'product',
                    //   contents: {
                    //     id: productId,
                    //     quantity: quantity
                    //   }
                    // });
                });
            }
            if (isIncrementalCart) {
                if (items.length > 0) {
                    incrementCartAdd(items.reverse(), false)
                        .then(() => {
                            window.location.href = '/checkout';
                        })
                        .catch((error) => {
                            console.error('Error adding extra product(s) to cart:', error);
                            checkoutButton.disabled = false;
                            checkoutButton.textContent = checkoutButton.dataset.defaultCta || 'Checkout';
                        });
                } else {
                    window.location.href = '/checkout';
                }
            } else {
                lockProductAddToCart(items.reverse(), 'checkout');
            }
        });
    }

    function resolveSingleAddonSellingPlanId() {
        const plansEl = document.getElementById('extra-products-popup-addon-selling-plans');
        let plans = [];
        try {
            plans = plansEl ? JSON.parse(plansEl.textContent) : [];
        } catch (e) {
            plans = [];
        }
        if (!plans.length) return null;
        const freqInput = document.querySelector('.product-form-v2 input[name="frequency"]:checked');
        const mainPlanName = freqInput ? freqInput.getAttribute('data-selling-plan-name') : null;
        const norm = (s) => String(s || '').trim().toLowerCase();
        if (mainPlanName) {
            const hit = plans.find((p) => norm(p.name) === norm(mainPlanName));
            if (hit) return parseInt(hit.id, 10);
        }
        return parseInt(plans[0].id, 10);
    }

    if (singleAddonAddBtn && isSingleAddonPopup) {
        singleAddonAddBtn.addEventListener('click', function () {
            singleAddonAddBtn.disabled = true;
            const inner = singleAddonAddBtn.querySelector('.extra-products-popup__single-primary-inner');
            if (inner) inner.textContent = 'Checking out...';

            const addonVariantId = parseInt(singleAddonAddBtn.getAttribute('data-variant-id'), 10);
            const sellingPlanAddon = resolveSingleAddonSellingPlanId();
            const parentRaw = popup ? popup.dataset.mainVariantId : null;
            const parentId = parentRaw ? parseInt(parentRaw, 10) : null;
            const parentLineKey = popup && popup.dataset.mainLineKey ? popup.dataset.mainLineKey : null;

            const addonLine = {
                id: addonVariantId,
                quantity: 1,
                properties: { 'Type': 'Extra Item' },
            };
            if (isIncrementalCart) {
                // Parent line already exists in the cart from the earlier
                // /cart/add.js request, so we nest the addon under it via
                // `parent_line_key` (Shopify Ajax Cart API for nested cart lines).
                if (parentLineKey) {
                    addonLine.parent_line_key = parentLineKey;
                }
            } else if (parentId && !Number.isNaN(parentId)) {
                addonLine.parent_id = parentId;
            }
            if (sellingPlanAddon && !Number.isNaN(sellingPlanAddon)) {
                addonLine.selling_plan = sellingPlanAddon;
            }
            if (isIncrementalCart) {
                incrementCartAdd(addonLine, false)
                    .then(() => {
                        window.location.href = '/checkout';
                    })
                    .catch((error) => {
                        console.error('Error adding addon product to cart:', error);
                        singleAddonAddBtn.disabled = false;
                        if (inner) {
                            inner.innerHTML = buildSingleAddonLabel(singleAddonAddBtn);
                        }
                    });
            } else {
                items.push(addonLine);
                lockProductAddToCart(items.reverse(), 'checkout');
            }
        });
    }

    if (checkoutSkipButton) {
        checkoutSkipButton.addEventListener('click', proceedExtraProductsPopupSkipCheckout);
    }
}

function renderShopifyProduct(handle, sectionId) {
    let url = `/products/${handle}?section_id=${sectionId}`;

    fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
            const container = document.createElement('div');
            container.innerHTML = responseText;

            // Clone the content and append it to a temporary container
            const tempContainer = document.createElement('div');
            tempContainer.appendChild(container.cloneNode(true));
            const boxPdpContainer = tempContainer.querySelector('.product-form-v2');
            const titleContainer = tempContainer.querySelector('.product-block.product-block--title .product_name');
            const descriptionContainer = tempContainer.querySelector('.product-block.product-block--description');
            const priceContainer = tempContainer.querySelector('.product-block.product-block--price');
            const stickyAddToCart = tempContainer.querySelector('.sticky-add-to-cart__container');

            // Replace the content of the existing #ProductAjaxContent with the content of the temporary container

            const existingTitleContainer = document.querySelector('.product-block.product-block--title .product_name');
            console.log('existingTitleContainer', existingTitleContainer);
            existingTitleContainer.innerHTML = titleContainer.innerHTML;

            const existingboxPdpContainer = document.querySelector('.product__information .product-form-v2');
            console.log('existingboxPdpContainer', existingboxPdpContainer);
            existingboxPdpContainer.innerHTML = boxPdpContainer.innerHTML;

            const existingDescriptionContainer = document.querySelector('.product-block.product-block--description');
            console.log('existingDescriptionContainer', existingDescriptionContainer);
            existingDescriptionContainer.innerHTML = descriptionContainer.innerHTML;

            const existingPriceContainer = document.querySelector('.product-block.product-block--price');
            console.log('existingPriceContainer', existingPriceContainer);
            existingPriceContainer.innerHTML = priceContainer.innerHTML;

            const existingStickyAddToCart = document.querySelector('.sticky-add-to-cart__container');
            console.log('existingStickyAddToCart', existingStickyAddToCart);
            existingStickyAddToCart.innerHTML = stickyAddToCart.innerHTML;


            // Re-initialize all event listeners and components
            initializeFormPDP();
            if (window.AppyGiftCredit && typeof window.AppyGiftCredit.init === 'function') {
                window.AppyGiftCredit.init(document, window);
            }


            // Check if returning from checkout
            // if (localStorage.getItem('returnFromCheckout') === 'true') {
            //     console.log('Returning from checkout, reloading page');
            //     localStorage.removeItem('returnFromCheckout');
            //     window.location.reload();
            // }
            window.history.pushState({ urlPath: handle }, '', handle);


        })
        .catch((e) => {
            console.error(e);
        });
}


window.addEventListener('load', function () {
    // Gift button moving under calendar
    var giftButton = document.querySelector('giftnote-button')
        ? document.querySelector('giftnote-button').closest('.product-block')
        : null;
    if (giftButton) {
        var giftButtonContainer = document.querySelector('.product-form-v2 .box-pdp--calendar-dropdown')
            ? document.querySelector('.product-form-v2 .box-pdp--calendar-dropdown')
            : null;
        if (giftButtonContainer) {
            giftButton.querySelector('.product-app').classList.add('giftnote-button-container');
            giftButtonContainer.appendChild(giftButton.querySelector('.product-app'));
        }
    }
});

/** Rebuild the single-addon button label HTML ("Add for <price> <s>compare</s>") from its data attributes. */
function buildSingleAddonLabel(btn) {
    const pre = btn.getAttribute('data-label-prefix') || '';
    const price = btn.getAttribute('data-price') || '';
    const compare = btn.getAttribute('data-compare-price') || '';
    let html = `${pre}<span class="extra-products-popup__single-price">${price}</span>`;
    if (compare) {
        html += `<s class="extra-products-popup__single-compare">${compare}</s>`;
    }
    return html;
}

/** After back/forward cache restore (e.g. back from checkout), close addon popup and reset its UI. */
function resetPdpExtraProductsPopupUi() {
    const popupEl = document.getElementById('extra-products-popup');
    if (!popupEl) return;

    popupEl.style.display = 'none';
    document.body.classList.remove('popup-open');
    document.documentElement.classList.remove('html-popup-open');

    const closeBtn = document.getElementById('close-extra-products-popup');
    const checkoutBtn = document.getElementById('extra-products-popup__checkout-button');
    const skipBtn = document.getElementById('extra-products-popup__skip');
    const singleAddonBtn = document.getElementById('extra-products-popup__single-addon-add');

    if (closeBtn) closeBtn.disabled = false;
    if (skipBtn) skipBtn.disabled = false;
    if (checkoutBtn) {
        checkoutBtn.disabled = false;
        if (checkoutBtn.dataset.defaultCta) {
            checkoutBtn.textContent = checkoutBtn.dataset.defaultCta;
        }
    }
    if (singleAddonBtn) {
        singleAddonBtn.disabled = false;
        const inner = singleAddonBtn.querySelector('.extra-products-popup__single-primary-inner');
        if (inner) {
            inner.innerHTML = buildSingleAddonLabel(singleAddonBtn);
        }
    }

    popupEl.querySelectorAll('.purchase-flow__product-card.active').forEach((card) => {
        card.classList.remove('active');
        const qtySel = card.querySelector('.purchase-flow-step__quantity-selector');
        const addBtn = card.querySelector('[data-add-to-order]');
        if (qtySel) qtySel.style.display = 'none';
        if (addBtn) addBtn.style.display = 'block';
        const input = card.querySelector('.purchase-flow-step__quantity-selector input');
        if (input) input.value = '1';
    });
}

window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        resetPdpExtraProductsPopupUi();
        var productV2AddToCart = document.querySelector('.product-form-v2 .box-pdp__v2-form-add-to-cart');
        if (productV2AddToCart) {
            productV2AddToCart.disabled = false;
        }
    }
});


// Add this new function to close all dropdowns
function closeAllDropdowns() {
    document.querySelectorAll('.box-pdp--custom-dropdown').forEach(dropdown => {
        dropdown.classList.remove('active');
        dropdown.classList.remove('open');
    });
}

// Add a click event listener to the document
document.addEventListener('click', function (event) {
    const isClickInsideDropdown = event.target.closest('.box-pdp--custom-dropdown');
    const isClickOnDropdownTrigger = event.target.closest('.box-pdp__delivery-item-value-wrapper');

    if (!isClickInsideDropdown && !isClickOnDropdownTrigger) {
        closeAllDropdowns();
    }

    const prefsWrapper = document.querySelector('.box-pdp__step--preferences');
    if (prefsWrapper) {
        // Only close if click is outside preferences section AND not on a preferences button
        if (!event.target.closest('.box-pdp__step--preferences') &&
            !event.target.closest('.preferences-button')) {
            prefsWrapper.querySelector('#prefs_wrapper').checked = false;
        }
    }

    const frequencyWrapperBelowButton = document.querySelector('.box-pdp__step--frequency-selector');
    if (frequencyWrapperBelowButton) {
        if (!event.target.closest('.box-pdp__step--frequency-selector')) {
            frequencyWrapperBelowButton.querySelector('#frequency-wrapper-below-button').checked = false;
        }
    }
});
function updateUnderButtonFrequency(label) {
    if (!label) { return; }
    const underButtonFrequency = document.querySelector('.frequency-wrapper-below-button__value');
    if (!underButtonFrequency) { return; }
    underButtonFrequency.textContent = label;
    const frequencyWrapperBelowButton = document.querySelector('#frequency-wrapper-below-button');
    if (frequencyWrapperBelowButton) {
        frequencyWrapperBelowButton.checked = false;
    }
}
function updateStickyAddToCartFrequency(label) {
    if (!label) { return; }
    console.log('label', label);
    const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
    if (!stickyAddToCart) { return; }
    stickyAddToCart.querySelector('.sticky-add-to-cart__box-frequency-value').textContent = label;
}
function updateStickyAddToCart(variant_info) {
    // if (!variant_info) { return; }
    let title , price;
    const active_Box = document.querySelector('.box-pdp__selection-input:checked');
    if (!active_Box) { return; }
    title = active_Box.getAttribute('data-title');
    price = active_Box.getAttribute('data-price');
    const stickyAddToCart = document.querySelector('.sticky-add-to-cart');
    if (!stickyAddToCart) { return; }
    stickyAddToCart.querySelector('.sticky-add-to-cart__box-name').textContent = title;
    stickyAddToCart.querySelector('.sticky-add-to-cart__box-price b').textContent = price;
}

function updateBundleBoxItemsCarousel(variant_info) {
    if (!variant_info || !window.bundleItemsflickitySlider) { return; }
    const bundleBoxItemsCarousel = document.querySelector('.box-pdp__bundle-items-carousel');
    if (!bundleBoxItemsCarousel) { return; }
    const bundleBoxItemsCarouselItems = bundleBoxItemsCarousel.querySelectorAll('.box-pdp__bundle-items-carousel-item');
    if (!bundleBoxItemsCarouselItems) { return; }
    bundleBoxItemsCarouselItems.forEach(item => {
        item.classList.add('hidden');
    });
    const bundleBoxItemsCarouselItem = bundleBoxItemsCarousel.querySelectorAll(`.box-pdp__bundle-items-carousel-item[data-variant-id="${variant_info.id}"]`);
    if (bundleBoxItemsCarouselItem) {
        bundleBoxItemsCarouselItem.forEach(item => {
            item.classList.remove('hidden');
        });
    }
    window.bundleItemsflickitySlider.resize();
}

function updateFrequencyInfo(variantId) {
    console.log('updateFrequencyInfo', variantId);
    if (!allVariants) { return; }
    const variant_info = allVariants.find(v => v.id === variantId);
    console.log('variant_info', variant_info);
    if (!variant_info) { return; }
    updateStickyAddToCart(variant_info);
    updateBundleBoxItemsCarousel(variant_info);

    const frequencySelector = document.querySelector('.box-pdp__selections.frequency-selector');
    const frequencySelectorInputs = frequencySelector.querySelectorAll('input[type="radio"]');
    const activeFrequencySelectorInput = frequencySelector.querySelector('input[type="radio"]:checked');

    var activeIndex = 0;
    if (activeFrequencySelectorInput) {
        activeIndex = Array.from(frequencySelectorInputs).indexOf(activeFrequencySelectorInput);
    }

    if (variant_info.selling_plans.length > 0) {
        frequencySelector.innerHTML = '';

        variant_info.selling_plans.forEach((plan, index) => {
            const input = document.createElement('input');
            input.type = 'radio';
            input.classList.add('box-pdp__selection-input');
            input.name = 'frequency';
            input.id = `frequency-${plan.SellingPlanID}`;
            input.value = plan.SellingPlanID;
            input.setAttribute('data-selling-plan-name', plan.Name);
            input.setAttribute('data-selling-plan-id', plan.SellingPlanID);


            if (index === activeIndex) {
                input.checked = true;
            }

            frequencySelector.appendChild(input);
            const frequencyName = plan.Name.replace('Delivery ', '').replace('Delivered', '');
            const label = document.createElement('label');
            label.classList.add('box-pdp__selection');
            label.setAttribute('for', `frequency-${plan.SellingPlanID}`);
            label.setAttribute('data-frequency-name', frequencyName);
            label.textContent = frequencyName;
            frequencySelector.appendChild(label);

            label.addEventListener('click', function () {
                updateStickyAddToCart(variant_info);
                updateStickyAddToCartFrequency(label.textContent);
                updateUnderButtonFrequency(label.textContent);
            });
        });
    }
}

function generateDeliveryOptions(weeks) {
    const options = [];
    const today = new Date();
    let currentDate = new Date(today);

    // Find the next Wednesday
    let daysUntilWednesday = (3 - currentDate.getDay() + 7) % 7;

    // If today is Tuesday, start from next week
    if (currentDate.getDay() === 2) {
        daysUntilWednesday += 7;
    }

    currentDate.setDate(currentDate.getDate() + daysUntilWednesday);

    for (let week = 0; week < weeks; week++) {
        const startDate = new Date(currentDate);
        const endDate = new Date(currentDate);
        endDate.setDate(endDate.getDate() + 2);  // Friday is 2 days after Wednesday

        const label = formatDateRange(startDate, endDate);
        const value = startDate.toISOString().split('T')[0]; // YYYY-MM-DD format

        // Corrected line:
        const shipDate = new Date(startDate);
        shipDate.setDate(shipDate.getDate() - 2);
        const _ship = shipDate.toISOString().split('T')[0];

        options.push({ label, value, _ship });

        // Move to next Wednesday
        currentDate.setDate(currentDate.getDate() + 7);
    }

    return options;
}



function formatDateRange(startDate, endDate) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    if (startDate.getMonth() === endDate.getMonth()) {
        return `${months[startDate.getMonth()]} ${startDate.getDate()}-${endDate.getDate()}`;
    } else {
        return `${months[startDate.getMonth()]} ${startDate.getDate()}-${months[endDate.getMonth()]} ${endDate.getDate()}`;
    }
}

function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function getUpsellProductItem() {
    const upsellCheckbox = document.querySelector('.upsell-product__checkbox')
        ? document.querySelector('.upsell-product__checkbox').checked
            ? document.querySelector('.upsell-product__checkbox').value
            : false
        : false;

    if (!upsellCheckbox) return null;

    return {
        id: parseInt(upsellCheckbox),
        quantity: 1,
    };
}

/**
 * Remove the cart lines a previous incremental Order Now click added (the customer closed the
 * popup and stayed on the PDP). Runs before the next incremental add so the fresh box replaces
 * the old one instead of merging into a quantity-2 line. Non-fatal on failure.
 */
function removeIncrementalCartLines(popupEl) {
    let keys = [];
    try {
        keys = JSON.parse(popupEl.dataset.addedLineKeys || '[]');
    } catch (error) {
        keys = [];
    }
    if (!Array.isArray(keys) || keys.length === 0) {
        return Promise.resolve();
    }
    delete popupEl.dataset.addedLineKeys;
    const updates = {};
    keys.forEach((key) => {
        updates[key] = 0;
    });
    return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ updates: updates }),
    }).catch((error) => {
        console.warn('[PDP add-to-cart] Could not remove previously added lines before re-adding.', error);
    });
}

function incrementCartAdd(itemsToAdd, includeUpsell) {
    if (!Array.isArray(itemsToAdd)) {
        itemsToAdd = [itemsToAdd];
    }

    const cartItems = itemsToAdd.slice();
    const upsellItem = includeUpsell ? getUpsellProductItem() : null;
    if (upsellItem) {
        cartItems.push(upsellItem);
    }

    // console.log('items', cartItems);

    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            items: cartItems,
        }),
    })
        .then(async (response) => {
            const text = await response.text();
            const data = text ? JSON.parse(text) : {};

            if (!response.ok) {
                const err = new Error(
                    (data && (data.description || data.message)) ||
                    'Shopify /cart/add.js failed with status ' + response.status
                );
                err.status = response.status;
                err.body = data;
                throw err;
            }

            // console.log('Product(s) added to cart:', data);
            return data;
        });
}

function lockProductAddToCart(items, action, onError) {
    // Ensure items is always an array
    if (!Array.isArray(items)) {
        items = [items];
    }


    var productV2AddToCart = document.querySelector('.product-form-v2 .box-pdp__v2-form-add-to-cart');
    if (action === 'checkout') {
        productV2AddToCart.disabled = true;
    }

    const upsellItem = getUpsellProductItem();
    if (upsellItem) {
        items.push(upsellItem);
    }

    console.log('items', items);


    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: items,
        }),
    })
        .then(async (response) => {
            const data = await response.json();
            if (!response.ok) {
                const error = new Error(data.description || data.message || 'The product could not be added to the cart.');
                error.status = response.status;
                throw error;
            }
            return data;
        })
        .then((data) => {
            console.log('Product(s) added to cart:', data);

            if (action === 'add') {
                const pageLock = document.querySelector('.product-locked');
                const unlockText = document.querySelector('.product-lock-unlocked-text');
                if (pageLock) {
                    pageLock.classList.remove('product-locked');
                }
                if (unlockText) {
                    unlockText.classList.remove('hidden');
                }
            } else if (action === 'checkout') {
                window.location.href = '/checkout';
                // if (checkoutDiscount) {
                //     window.location.href = `/checkout?discount=${checkoutDiscount}`;
                // } else {
                //     window.location.href = '/checkout';
                // }
            }
            // You can add more actions here if needed
        })
        .catch((error) => {
            console.error('Error adding product(s) to cart:', error);
            if (typeof onError === 'function') {
                onError(error);
            }
            // Optionally, you can show an error message to the user
        });
}
